import React from "react";
import "../styles/Spinner.css";

const Spinner = () => {
  return (
    <div className="spinner-main">
      <div className="loader"></div>
    </div>
  );
};

export default Spinner;
